import { call, put } from "redux-saga/effects";

import * as actions from "../actions";

import { getNotifications, getReadDate } from "../../api/notifications-api";
import { updateLastReadDate } from "../../api/fontApi";

export const getProfile = (state) => state.core && state.core.app;

function* loadNotifications() {
  try {
    const response = yield call(getNotifications);
    if (response.status === 200) {
      yield put(actions.notificationSuccess(response.data));
    } else {
      yield put(actions.notificationError("get notifications error", response));
    }
  } catch (error) {
    yield put(actions.notificationError(error));
  }
}

function* getLastReadDate() {
  try {
    const response = yield call(getReadDate);
    if (response.status === 200) {
      yield put(
        actions.notificationLastReadSuccess(response.data.lastTimestamp)
      );
    } else {
      yield put(
        actions.notificationLastReadError("get last read date error", response)
      );
    }
  } catch (error) {
    yield put(actions.notificationLastReadError(error));
  }
}

function* updateLastRead() {
  try {
    const response = yield call(() => updateLastReadDate());
    if (
      response &&
      response.result &&
      response.result === "Last Read date updated."
    ) {
      yield put(actions.notificationReadUpdateSuccess(new Date()));
    } else {
      yield put(
        actions.notificationReadUpdateError(
          "update last read date error",
          response
        )
      );
    }
  } catch (error) {
    yield put(actions.notificationReadUpdateError(error));
  }
}

export { loadNotifications, getLastReadDate, updateLastRead };
